import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotasIngresoComponent } from 'app/modals/apoyo-usuario/beneficiarios/opciones/notas-ingreso/notas-ingreso.component';
import { NotasSeguimientoComponent } from 'app/modals/apoyo-usuario/beneficiarios/opciones/notas-seguimiento/notas-seguimiento.component';
import { InformesService } from 'app/services/informes.service';
import { HistoriaClinicaComponent } from 'app/modals/historia-clinica/historia-clinica.component';
import { InformacionComponent } from 'app/modals/apoyo-usuario/beneficiarios/opciones/informacion/informacion.component';
import { DatosOpcModal } from 'app/entities/datos-opc-modal';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OpcionesModalService {
  private nSegui_close;

  constructor(private dialog: MatDialog, private _snackBar: MatSnackBar, private _informe: InformesService) { }

  public Modales(opcion: string, datos: DatosOpcModal): Observable<any>{
    let modal;
    switch(opcion){
      case 'nIngresar':
        this.dialog.open(NotasIngresoComponent, {
          data: datos.notasIngresoAP
        });
        break;
      case 'nSegui':
        modal = this.dialog.open(NotasSeguimientoComponent, {
          width: '35%',
          data: {
            indice: datos.indice,
            apoyoUsuSegui: datos.ApoUsuSegui,
            idApoyo: datos.apoyo_id
          }
        });
        modal.afterClosed().subscribe((result:any) => {
          this.nSegui_close = result;
        });
        break;
      case 'PasarAud':
        this._informe.CrearAuditoriaBeneficiarios(datos.bendoc, datos.apoyo_id).subscribe((data:any) => {
          if(data.estatus == 1){
            this._snackBar.open('Se ha guardado la auditoría.', 'Aceptar', {
              duration: 2000
            });
          }else{
            this._snackBar.open('Error al guardar la auditoría', 'Aceptar', {
              duration: 2000
            });
          }
        })
        break;
      case 'HCli':
        this.dialog.open(HistoriaClinicaComponent, {
          height: '85%',
          width: '55%',
          data: {
            tipo: datos.tipo_hc,
            bendoc: datos.bendoc
          }
        });
        break;
      case 'Info':
        this.dialog.open(InformacionComponent, {
          data: datos.bendoc
        })
        break;
    }
    return of(this.nSegui_close);
  }


}
